import dictionatyNameService from './financingService';

export default dictionatyNameService;



// WEBPACK FOOTER //
// ./src/services/financigservice/index.ts